<template>
<div style="padding: 10px 20px;">

    <p>
    Invite your Team members to DataMapper and decide what User Groups they will be part of.
    <br> You may give Team members an "Admin" role for them to make changes to your DataMapper setup.
    </p>

    <h4>Manage Users
    <custom-tooltip :tooltip-text='tooltipInfo'/>
    </h4>

    <user-page
        ref="userPage"
        :roles="roles"
        :groups="allGroups"
        :show-meta="false"
        :extra-menu="team.menu"
        :user-list="team.userList"
        :defaultDropdownGroupId='defaultDropdownGroupId'
        :tooltip-size="0.7"
        @exists="userExist"
        @menuclick="menuClick"
        @sendinvite="inviteUsers"
        @addgroup="onAccessChange"
        @rolechange="onAccessChange"
        @removegroup="onAccessChange"
        @sendallinvites="sendAllInvites"
        @sendpendinginvites-exist="userExist"


    />

    <div class="bottom-action">
        <button class="continue simple" @click="inviteAllUsers">Invite Users</button>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

import store from '@/account/store'
import { Defaults } from 'archii-web-components'

const tooltipInfo = `Change roles and groups of existing users or invite new users to join DataMapper.
    You can assign roles and groups before inviting.`

const ALL_GROUPS_NAME = 'All users'

export default {
    data() {
        return {
            tooltipInfo,
            updatedUsers: [],
            roles: Object.keys(Defaults.ROLES).map((key) => Defaults.ROLES[key]),
            team: {
                userList: [],
                menu: [{
                    target: '#groups',
                    text: "Go to 'User groups'"
                }]
            },
            currentUser: {}
        }
    },

    computed: {
        ...mapState({
            allGroups: 'groups',
        }),

        defaultDropdownGroupId () {
            const defaultGroup = this.allGroups.find(g => g.name === ALL_GROUPS_NAME)
            const id = defaultGroup ? defaultGroup.id : undefined
            return id
        }
    },

    created () {
        this.currentUser = this.$store.state.currentUser

        this.$store.dispatch('getAllGroups')

        this.getUsers()
    },

    methods: {
        getUsers () {

            this.$Api.admin.user.getAllUsers().then(response => {
                const isCurrentUser = user => this.currentUser.username === user.username

                var users = response
                const sortingOrder = function (user1, user2) {
                    if (isCurrentUser(user1)) return -1
                    else if (isCurrentUser(user2)) return 1
                    else return user1.username.localeCompare(user2.username)
                }

                users.sort(sortingOrder)

                this.team.userList = users.map(user => {
                    return Object.assign({}, user, {rolesReadOnly: isCurrentUser(user.username)})
                })
            })
        },
        inviteAllUsers() {
            this.$refs.userPage.sendPendingInvites()

            this.updatedUsers.forEach(user => {
                this.$Api.admin.user.updateAccess({
                    roles: user.roles,
                    user_id: user.user_id,
                    access_groups: user.access_groups
                })
            })
        },

        sendAllInvites (rows) {

            const invitationPromises = Promise.all(rows.map(this.inviteUsers))

            invitationPromises
                .then(() => {
                    this.$store.commit('next')
                })
        },

        inviteUsers (row) {

            if(!row.emails.length) return

            return this.$Api.admin.sendInvitation({
                roles: row.roles,
                message: row.message,
                userEmails: row.emails,
                accessGroups: row.accessGroups
            }).then(res => {

                this.getUsers()

            }).catch(err => {

                if (err.response && err.response.status === 400) {
                    this.$refs.userPage.removeUsers(err.response.data.emails)
                    this.userExist(err.response.data.emails)
                }
                throw err
            })
        },

        onAccessChange(change) {
            if(change.user.user_id) { // role change in user list
                this.updatedUsers[change.user.user_id] = change.user
            }
        },

        menuClick (target) {
            if (target === '#groups') {
                this.$store.commit('back')
            }
        },

        userExist (emails) {
            this.$store.dispatch('error', `These users are already on this team: ${emails.join(', ')}`)
        }
    }
}
</script>

<style lang='scss'>
.vue-input-tag-wrapper.invite-emails .new-tag {
  margin: 0;
  padding: 0;
  border: none;
}

.invite-row .group-dropdown .trigger {
  max-width: 110px;
}
</style>





// WEBPACK FOOTER //
// apps/account/Team.vue